/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getFileImportDetails } from "api/services/fileImport";
import { fileImportQueryKeys } from "./fileImportQueryKeys";

export function useGetFileImportDetails(id: string, options: UseQueryOptions) {
  return useQuery({
    queryKey: fileImportQueryKeys.fileImportDetails(id),
    queryFn: () => getFileImportDetails(id).then((res) => res.data),
    ...options,
  });
}
